module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Regular.ttf?22ea3e22ea615594d1948b979e3d33b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Regular.ttf
// module id = 1420
// module chunks = 0